<script lang="ts">
  export type PageLayoutProps = PageProviderProps & {
    headerProps: PageHeaderProps
  }
</script>

<script setup lang="ts">
  import PageProvider, { type PageProviderProps } from '../PageProvider.vue'
  import PageMain, { type PageMainProps } from '../PageMain.vue'
  import PageHeader, { type PageHeaderProps } from '../PageHeader.vue'
  import PageBody, { type PageBodyProps } from '../PageBody.vue'
  import { onMounted } from 'vue'

  defineOptions({
    inheritAttrs: false
  })

  const props = withDefaults(defineProps<PageLayoutProps>(), {})
</script>
<template>
  <PageProvider :class="props.class">
    <PageMain v-bind="props.mainProps">
      <PageHeader v-bind="props.headerProps">
        <template #title>
          <slot name="title" />
        </template>
        <template #default>
          <slot name="actions" />
        </template>
        <template #header>
          <slot name="header" />
        </template>
      </PageHeader>
      <AccessDenied v-bind="props.accessProps">
        <PageBody v-bind="props.bodyProps">
          <slot />
        </PageBody>
      </AccessDenied>
    </PageMain>
  </PageProvider>
</template>
